import React from "react";
import { Images } from "../../../Assets/0a-exporter";
import "./custom-dropdown.style.scss";
export default function CustomDropdown({
  title,
  error = false,
  selected,
  list = [],
  message,
  sendClicked
}) {
  const [selectedDropdown, setSelectedDropdown] = React.useState();
  const [openList, setOpenList] = React.useState(false);
  const [searchTerm, setSearchTerm] = React.useState("");
  const node = React.useRef();
  const handleClick = (e) => {
    if (node.current && node.current.contains(e.target)) {
    } else {
      setOpenList(false);
    }
  };
  React.useEffect(() => {
    try {
      if (!selected) {
        setSelectedDropdown();
        return;
      }
      let temp = list.find((x) => {
        return x.id == selected || x._id == selected;
      });
      setSelectedDropdown({ ...temp });
      
    } catch (error) {
      console.error("compare selected", error);
      
    }
  }, [selected, list]);
  React.useEffect(() => {
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);
  return (
    <div
      ref={node}
      style={error ? { border: "1px solid red" } : {}}
      className="custom-dropdown-main"
    >
      {title && <span style={error ? { color: "red" } : {}}>{title}</span>}
      <div
        onClick={(e) => {
          setOpenList(!openList);
          e.stopPropagation();
        }}
        className="selected"
      >
        {openList ? (
          <input
            placeholder="search..."
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
            value={searchTerm}
          />
        ) : (
          <>
            {selectedDropdown ? (
              <p>{selectedDropdown.name}</p>
            ) : (
              <p className="d-text" className="text_low_opacity">
                {message}
              </p>
            )}
            {/* <img className="d-img" src={Images.upDown} /> */}
          </>
        )}
      </div>
      <ul className={`fid-dropdown ${openList ? "show-list" : ""}`}>
        {!list.length ? (
          <li disabled>No Data Available</li>
        ) : (
          list
            .filter((x) =>
              x.name.toLowerCase().startsWith(searchTerm.toLowerCase())
            )
            .map((obj) => (
              <li
                onClick={() => {
                  setSelectedDropdown(obj);
                  sendClicked(obj);
                  setOpenList(false);
                }}
              >
                {obj.name}
              </li>
            ))
        )}
      </ul>
    </div>
  );
}
